<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-item size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New Competency</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data"> {{ data.index + 1 }} </template>
                <template #cell(term)="data">
                  {{ data.item.term.name }} - {{ data.item.year }}
                </template>
                <template #cell(class)="data">
                  {{ data.item.class.name }}
                </template>
                <template #cell(subject)="data">
                  {{ data.item.subject.name }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="
                        edit(
                          data.item.id,
                          data.item.class,
                          data.item.subject,
                          data.item.competency,
                          data.item.unit,
                          data.item.description,
                          data.item.term,
                          data.item.year,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button
                      @click="remove(data.item.id, data.item.competency)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="new-item"
      centered
      title="New Competency"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addItem">
        <div class="form-group mb-2">
          <div class="row">
            <b-form-group class="col-md-6" label="Year">
              <v-select
                :options="years"
                placeholder="Select Year"
                v-model="year"
              ></v-select>
            </b-form-group>
            <b-form-group class="col-md-6" label="Term">
              <v-select
                :options="schoolterms"
                placeholder="Select Term"
                @input="FilterExams"
                v-model="schoolterm"
                label="name"
              ></v-select>
            </b-form-group>
          </div>
          <label class="mt-2">Class</label>
          <multiselect
            v-model="schoolclass"
            @input="FilterSubjects"
            label="name"
            :options="schoolclasses.filter((c) => c.level == 2)"
          ></multiselect>
          <label>Subjects</label>
          <v-select
            :options="schoolsubjects"
            placeholder="Select Subject"
            v-model="schoolsubject"
            label="name"
          ></v-select>
          <label>Competency Name</label>
          <input v-model="competencyname" type="text" class="form-control" />
          <label>Unit</label>
          <select class="form-control" v-model="unit">
            <option>U1</option
            ><option>U2</option
            ><option>U3</option
            ><option>U4</option>
          </select>
          <label>Description</label>
          <textarea v-model="description" rows="3" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('new-item')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> Submit</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      id="edit-item"
      centered
      title="Edit Competency"
      title-class="font-14"
      hide-footer
    >
      <form @submit.prevent="editItem">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden" />
          <div class="row">
            <b-form-group class="col-md-6" label="Year">
              <v-select
                :options="years"
                placeholder="Select Year"
                v-model="year"
              ></v-select>
            </b-form-group>
            <b-form-group class="col-md-6" label="Term">
              <v-select
                :options="schoolterms"
                placeholder="Select Term"
                @input="FilterExams"
                v-model="schoolterm"
                label="name"
              ></v-select>
            </b-form-group>
          </div>
          <label class="mt-2">Class</label>
          <multiselect
            v-model="schoolclass"
            @input="FilterSubjects"
            label="name"
            :options="schoolclasses"
          ></multiselect>
          <label>Subjects</label>
          <v-select
            :options="schoolsubjects"
            placeholder="Select Subject"
            v-model="schoolsubject"
            label="name"
          ></v-select>
          <label>Competency Name</label>
          <input v-model="competencyname" type="text" class="form-control" />

          <label>Unit</label>
          <select class="form-control" v-model="unit">
            <option>U1</option
            ><option>U2</option
            ><option>U3</option
            ><option>U4</option>
          </select>

          <label>Description</label>
          <textarea v-model="description" rows="3" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('edit-item')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> Submit</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      id="delete-item"
      centered
      title="Delete Competency"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="removeItem">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete the Stream :
        <b>{{ competencyname }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('delete-item')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> YES</b-button
          >
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  subjectcompetencyComputed,
  subjectcompetencyMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Competencies",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Competencies",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Competencies", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "term", label: "Term", visible: true },
        { key: "class", label: "Class", visible: true },
        { key: "subject", label: "Subject", visible: true },
        { key: "competency", label: "Competency", visible: true },
        { key: "unit", label: "Unit", visible: true },
        { key: "addedby", label: "Added by", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      schoolclass: "",
      schoolsubjects: [],
      schoolsubject: "",
      competencyname: "",
      unit: "",
      description: "",
      schoolterm: "",
      year: "",
    };
  },
  computed: {
    ...schooltermComputed,
    ...subjectcompetencyComputed,
    ...schoolclassComputed,
    List() {
      return this.subjectcompetencies.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.subjectcompetencies.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.subjectcompetencies.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear;
      const endYear = currentYear - 10;
      const yearArray = [];
      for (let year = startYear; year >= endYear; year--) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSubjectCompetencies();
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.TotalRows = this.subjectcompetencies.length;
    this.isBusy = false;
  },
  methods: {
    ...subjectcompetencyMethods,
    ...schooltermMethods,
    ...schoolclassMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, schoolclass, schoolsubject, name, unit, description, term, year) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.schoolsubject = schoolsubject;
      this.competencyname = name;
      this.unit = unit;
      this.description = description;
      this.schoolterm = term;
      this.year = year;
      this.$bvModal.show("edit-item");
    },
    remove(id, name) {
      this.id = id;
      this.competencyname = name;
      this.$bvModal.show("delete-item");
    },
    async FilterSubjects() {
      let url = `/findsubjects/${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.schoolsubjects = response.data.subjects;
      });
    },
    async addItem() {
      let formData = new FormData();
      formData.append("class", this.schoolclass.id);
      formData.append("subject", this.schoolsubject.id);
      formData.append("competency", this.competencyname);
      formData.append("unit", this.unit);
      formData.append("description", this.description);
      formData.append("term", this.schoolterm.id);
      formData.append("year", this.year);
      let url = "/addsubjectcompetency";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSubjectCompetencies();
          this.$bvModal.hide("new-item");
          this.schoolclass = "";
          this.schoolsubject = "";
          this.competencyname = "";
          this.unit = "";
          this.schoolterm = "";
          this.year = "";
          this.description = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editItem() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("class", this.schoolclass.id);
      formData.append("subject", this.schoolsubject.id);
      formData.append("competency", this.competencyname);
      formData.append("unit", this.unit);
      formData.append("description", this.description);
      formData.append("term", this.schoolterm.id);
      formData.append("year", this.year);
      let url = "/updatesubjectcompetency";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSubjectCompetencies();
          this.$bvModal.hide("edit-item");
          this.schoolclass = "";
          this.schoolsubject = "";
          this.competencyname = "";
          this.unit = "";
          this.schoolterm = "";
          this.year = "";
          this.description = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeItem() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesubjectcompetency";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSubjectCompetencies();
          this.$bvModal.hide("delete-item");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
